/* eslint-disable */
/* This file extends the functionality provided by Backbone Router and Views, by:
 *  - creating a way for regions to be defined and used to create swappable layout
 *  - triggering events like 'view:appended', 'view:merged', and 'view:closed'
 *  - detecting when a view has an unsaved model and throwing up a warning upon leaving the view
 *  - making sure to handle internal links through the router, to avoid page refresh
 *  - making sure to still handle CTRL+clicking on links correctly
 */
import $ from 'jquery';

import Q from 'q';
import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'underscore';
import confirmNavigationTemplate from 'bundles/confirmNavigation/confirmNavigation.html';
import ContextProvider from 'bundles/common/components/provideContext';
import provideRequestCountryCodeContext from 'bundles/phoenix/utils/provideRequestCountryCodeContext';
import log from 'js/app/loggerSingleton';
import Modal from 'js/lib/modals';
import Backbone from 'backbone';

var BACKBONE_REGION = 'backbone_region';
var REACT_REGION = 'react_region';

// provide a simpler super method in case we want to extend a backbone view function
Backbone.View.prototype._super = function(funcName) {
  return this.constructor.__super__[funcName].apply(this, _.rest(arguments));
};

var _singleton = null;

var _private = {
  current: null,
  body: '#origami',
  views: {},
  openDepth: 0,
  beforeUnloadMessage: 'There are unsaved changes that will be lost if ' + 'you reload or leave this page.',
  regionHasUnsavedModel: function(region) {
    // Return whether the given region's view or any of its sub-regions'
    // views have unsaved models.
    //
    // This is determined by calling hasUnsavedModel() on each of the views.
    // It is okay for views to not implement this method, in which case the
    // view is assumed to not have an unsaved model.
    if (!region) return false;
    var viewHasUnsavedModel = region.view && region.view.hasUnsavedModel ? region.view.hasUnsavedModel() : false;

    if (viewHasUnsavedModel) {
      return true;
    } else {
      for (var name in region.regions) {
        var subRegion = region.regions[name];
        if (_private.regionHasUnsavedModel(subRegion)) {
          return true;
        }
      }
      return false;
    }
  },
};

var router = Backbone.Router.extend({
  // turn are .internal links to routes
  initialize: function() {
    var self = this;
    self.routePrefix = '';
    this.visitedFragments = [];

    // This element will be used by the modal used to confirm navigation,
    // when relevant.
    this.$confirmNavigation = $(confirmNavigationTemplate({}));
    $('body').append(this.$confirmNavigation);

    $(window).on('beforeunload.origami', function() {
      if (_private.regionHasUnsavedModel(_private.current)) {
        return _private.beforeUnloadMessage;
      }
    });
  },

  setupLinks: function(routePrefix, linkSelector) {
    var self = this;

    this.routePrefix = routePrefix;
    this.linkSelector = linkSelector;
    $('body').on('click', 'a' + this.linkSelector, function(e) {
      if (!e.ctrlKey && !e.metaKey) {
        e.preventDefault();
        self.navigateTo($(e.currentTarget).attr('href'), true);
      }
    });
  },

  addFragmentToVisited: function(fragment, options) {
    if (typeof options === 'object' && options.replace) {
      return;
    }
    if (this.visitedFragments) {
      this.visitedFragments.push(fragment);
    } else {
      this.visitedFragments = [fragment];
    }
  },

  navigateTo: function(href, options) {
    if (!href) {
      log.error('router.navigateTo received no href');
    }

    this.navigate(href.replace(this.routePrefix, ''), options);
  },

  // Override navigate(..) to allow cancelling of navigation when a view has
  // an unsaved model.
  //
  // Views may implement a method, hasUnsavedModel().  This method will be
  // called on any navigation, including both browser navigation and
  // application navigation.  If this method returns true, a dialog will be
  // presented to the user warning them that unsaved changes will be lost if
  // they continue with navigation.  For browser navigation, this will be a
  // browser dialog.  For application navigation, this will be a Modal
  // dialog.  The user may cancel or continue with the navigation.
  //
  // If the view does not implement hasUnsavedModel(), navigation will be
  // allowed.
  //
  // There may be multiple active views, by way of regions and subregions.
  // If any view's hasUnsavedModel() method returns true, the confirmation
  // dialog will be shown.
  navigate: function(fragment, options) {
    if (_private.current && _private.regionHasUnsavedModel(_private.current)) {
      var $message = $('.confirm-navigation-message');
      $message.text(_private.beforeUnloadMessage);

      var $leave = $('.confirm-navigation-leave');
      $leave.one(
        'click',
        function(e) {
          this.addFragmentToVisited(fragment);
          Backbone.Router.prototype.navigate.call(e.currentTarget, fragment, options);
        }.bind(this)
      );

      var modalOptions = {
        'overlay.class': 'coursera-overlay',
      };
      Modal('.confirm-navigation', modalOptions).open();
    } else {
      this.addFragmentToVisited(fragment, options);
      Backbone.Router.prototype.navigate.call(this, fragment, options);
    }
  },

  // convenience function to add routes outside of this context
  // routeCallbackWrapper allows you to specify a function that wraps all the route callbacks
  addRoutes: function(routes, routeCallbackWrapper) {
    var self = this;

    for (var route in routes) {
      var routeCallback = routes[route];

      if (routeCallbackWrapper) {
        routeCallback = routeCallbackWrapper(routeCallback);
      }

      self.route(route, route, routeCallback);

      // TODO
      // move this more internally into backbone such that
      // we are not generating

      // let's handle versions of all routes that end in a trailing slash
      // such that it redirects to the non-slash version
      // don't push it in the history buffer, or it will kill back button
      self.route(route + '/', route + '/', function() {
        var url = Backbone.history.getFragment();
        var rewrite = url.replace(/\/(?:\?.*)*$/, '');

        self.navigate(rewrite, {
          trigger: true,
          replace: true,
        });
      });
    }
  },

  start: function(rootPath) {
    var routeSuccess = Backbone.history.start({
      pushState: true,
      hashChange: false,
      root: rootPath,
    });
    if (!routeSuccess) {
      this.trigger('error', 404);
    }
  },

  unsavedWarningModal: function(callback) {
    if (_private.current && _private.regionHasUnsavedModel(_private.current)) {
      var modalOptions = {
        'overlay.class': 'coursera-overlay',
      };

      var $message = $('.confirm-navigation-message');
      $message.text(_private.beforeUnloadMessage);

      var modal = Modal('.confirm-navigation', modalOptions);

      modal.once('action', option => {
        callback(option);
      });

      modal.open();
    } else {
      callback(true);
    }
  },
});

// regions are basically syntactic sugar for backbone views
// they provide methods to better handle views that contain other views
// which comes in handy when you want a view to replace another view
var region = function(type, _options) {
  var self = this;
  var options = _options || {};

  self.type = type;
  self.regions = options.regions || {};
  self.initialize = options.initialize || {};
  self.to = options.to;
  self.options = {};
  self.props = _options.props || {}; // for React
  self.context = _options.context || {};
  self.fluxibleContext = _options.fluxibleContext;
  self.reactRouter = _options.reactRouter;

  self.id = options.id || type.prototype.name;

  // Origami uses the region name as the key for merging two region hierarchies.
  // This line gets region name from the Backbone view or the region declaration,
  // (the latter being the only method for declaring on React-based region declarations).
  self.name = type.prototype.name || options.name;

  self.view = null;
  self.regions = $.extend({}, type.prototype.subregions, options.regions || {});
};

// close a region and remove its events. if keep == true, don't remove the DOM
region.prototype.close = function(keep) {
  var self = this;

  _.each(self.regions, function(_region, key) {
    delete self.regions[key];
    if (_region) {
      _region.close(keep);
    }
  });

  self.view.trigger('view:closed');

  if (!keep) self.view.remove();

  self.view.undelegateEvents();
  self.view.off('view');
};

// close a region and remove its events and if remove == true, remove it from the dom
region.prototype.closing = function() {
  this.view.trigger('view:closing');
  delete _private.views[this.view.cid];
};

/**
 * Render the region
 *
 * @return {region} the region that was rendered, with view.el set
 */
region.prototype.render = function(origami) {
  var self = this;

  // Skip regions that have been nullified by removing keys in regions that
  // map to falsy values
  var regions = _.compact(_.values(self.regions));
  _.each(regions, function(subregion) {
    subregion.render();
    subregion.parent = self;
  });

  // https://discuss.reactjs.org/t/how-to-determine-if-js-object-is-react-component/2825/5
  // isReactComponent is an undocumented property on React component prototypes made from
  // both 'React.createClass' and 'extends React.Component'
  if (this.type.prototype.isReactComponent) {
    this.kind = REACT_REGION;
    this.renderReactComponent();
  } else {
    this.kind = BACKBONE_REGION;
    this.renderBackboneView();
  }

  // Attach subregion elements if not already attached
  _.each(regions, function(subregion) {
    var el = subregion.view && subregion.view.el;
    // 'to' passed to region takes precedence
    var to = subregion.to || (subregion.view && subregion.view.to);
    if (_.isFunction(to)) {
      to = to();
    }
    if (to && !$.contains(document, el)) {
      self.view.$(to).append(el);
      subregion.appended();
    }
  });

  if (origami) {
    self.view.on('view:appended', function() {
      origami.trigger('region:appended', {
        name: self.name,
      });
    });
  }

  return self;
};

region.prototype.renderBackboneView = function() {
  this.view = new this.type(this.initialize);

  this.view.region = this;
  this.view.render(this.render);
};

region.prototype.renderReactComponent = function() {
  const fluxibleContext = this.context.fluxibleContext;
  const reactRouter = this.context.router;
  const customContext = Object.assign(
    {},
    fluxibleContext
      ? {
          fluxibleContext,
          ...fluxibleContext,
        }
      : {},
    reactRouter ? { router: reactRouter } : {}
  );

  const Component = _.compose(provideRequestCountryCodeContext)(this.type);

  // act like a Backbone view for Origami
  this.view = new Backbone.View();

  this.view.region = this;

  const component = (
    <ContextProvider customContext={customContext}>
      <Component {...this.props} />
    </ContextProvider>
  );

  this.view.remove = function() {
    ReactDOM.unmountComponentAtNode(this.el);
    Backbone.View.prototype.remove.call(this);
    return this;
  };

  this.view.on('view:appended', function() {
    ReactDOM.render(component, this.el);
  });
};

// allows regions to know when they are alive
region.prototype.appended = function() {
  var that = this;

  if (that.view) {
    setTimeout(function() {
      that.view.trigger('view:appended');
    }, 0);
  }
};

region.prototype.append = function(view, options) {
  var that = this;

  var appended = Q.defer();

  if (!this.regions) this.regions = {};

  var renderAndAppend = function(_region) {
    var key = view;
    var count = 0;
    var $el;

    // rename the key if already exists
    while (that.regions[key]) {
      key = key + ++count;
    }

    that.regions[key] = _region;

    _region.render(_singleton);

    if (options.to) {
      $el = _.isElement(options.to) ? that.view.$(options.to) : options.to;
    } else {
      $el = that.view.$el;
    }

    // If options.position exists, insert this view such that it is the
    // options.position-th child of $el.
    if (_(options).has('position')) {
      var wasInPosition = $el.children().eq(options.position);
      if (wasInPosition.length > 0) {
        $(wasInPosition[0]).before(_region.view.el);
      } else {
        $el.append(_region.view.el);
      }
    } else {
      $el.append(_region.view.el);
    }
    _region.appended();

    _singleton.renderedRegions.push(_region);
    _singleton.trigger('region:rendered', {
      name: _region,
    });

    appended.resolve(_region);
  };

  if (view !== undefined) {
    if (typeof view === 'string') {
      _singleton.region.fetch(view, options, renderAndAppend);
    }
    else renderAndAppend(new region(view, options));
  }
  return appended.promise;
};

// useful to compare if two regions are the same
region.prototype.is = function(_region) {
  return _region.type == this.type && _region.id == this.id;
};

// merge this region with another (eventually replacing itself)
region.prototype.replace = function(incoming, callback) {
  this.view.$el.replaceWith(incoming.view.el);
  if (callback) callback();
};

// take two outer regions and merge only the regions that are different
region.prototype.merge = function(incoming, origami) {
  var self = this;

  // if regions are the same
  if (self.is(incoming)) {
    _.each(incoming.regions, function(incomingRegion, view) {
      var targetRegion = self.regions[view];
      // Sometimes we nullify regions, so we only want to merge when regions exist on both sides.
      if (targetRegion && incomingRegion) {
        targetRegion.view.trigger('view:merging', incomingRegion.initialize);
        targetRegion.merge(incomingRegion, origami);
        targetRegion.view.trigger('view:merged', incomingRegion.initialize);
      } else if (targetRegion && !incomingRegion) {
        targetRegion.closing();
        if (targetRegion.parent) {
          delete targetRegion.parent.regions[targetRegion.name];
        }
        targetRegion.close();
      }
    });
  } else if (self.name == incoming.name) {
    self.closing();
    incoming.render(origami);

    self.replace(incoming, function() {
      if (self.parent) {
        self.parent.regions[incoming.name] = incoming;
        incoming.parent = self.parent;
        self.parent.appended();
      }

      self.close();
      incoming.appended();
    });
  }
};

// actual region manager that makes regions and replaces them
//var regionManager = function(Base)
var Origami = function(body, current) {
  if (_singleton) {
    return _singleton;
  }

  // Keep track of regions so we can introspect them later on.
  this.renderedRegions = [];

  _singleton = this;
  _private.body = body;
  _private.current = current;

  $(window).on('resize', function() {
    for (var cid in _private.views) {
      _private.views[cid].trigger('view:resize');
    }
  });

  // open up an outer region, closing any existing regions in its place
  this.region = {
    make: function(type, options) {
      return new region(type, options);
    },

    fetch: function(_region, conf, callback) {
      var uid = _.uniqueId();
      _singleton.trigger('region:fetching', {
        name: _region,
        uid: uid,
      });

      var returnRegion = view => {
        _singleton.trigger('region:fetched', {
          name: _region,
          uid: uid,
        });

        // hide message here
        callback(new region(view, conf));
      };

      /*
       * There are three ways to specify the module needed to fulfill this region request.
       * 1. Specify in the region configuration a `module` key with a reference to an existing module
       * 2. Specify in the region configuration a `module` key with a reference to a
       * function that returns a module (lazy)
       * 3. Specify nothing and let the key for the region determine the module (DEPRECATED). This is
       * deprecated because Webpack cannot handle dynamic references to modules that are not known at
       * compile time.
       */
      var { module, async } = conf;
      if ((module && module.lazy) || (module && async)) {
        // Module is coming through the lazy plugin
        module(returnRegion);
      } else if (!!module) {
        // Module was already defined, we can return it directly.
        returnRegion(module);
      } else {
        let req;
        // trick post processor to not post process this require call
        // note, this is for compatbility with Jest, where async requires
        // aren't a thing.
        // TODO: Change this to something that works for other things like webpack.
        if (jest?.requireActual) {
          req = function(regions, func) {
            const view = require(regions[0]);
            return func(view);
          };
        } else {
          req = require;
        }
        // DEPRECATED -- modules must be passed as a key on the region configuration.
        _singleton.trigger('deprecatedUsage', {
          type: 'asyncRequire',
          name: _region,
        });
        req([_region], returnRegion);
      }
    },

    getSingleton: function() {
      return _singleton;
    },

    // append the region
    // if only given only a region name it must be fetched, callback is used
    // if given a Backbone.View directly, then it will return immediately
    append: function(parent, view, options, callback) {
      if (!parent)
        parent = {
          regions: {},
        };

      var renderAndAppend = function(_region) {
        var key = view;
        var count = 0;

        while (parent.regions[key]) {
          key = key + ++count;
        }

        parent.regions[key] = _region;
        _region.render(_singleton);
        // addToDom
        //
        if (callback) callback(_region);
        _region.appended();

        _singleton.renderedRegions.push(_region);
        _singleton.trigger('region:rendered', {
          name: _region,
        });

        return _region;
      };

      if (view !== undefined) {
        if (typeof view === 'string') {
          _singleton.region.fetch(view, options, renderAndAppend);
        }
        else return renderAndAppend(new region(view, options));
      }
    },

    open: function(name, callback) {
      var view = name;
      var conf = {};

      if (_private.openDepth === 0) {
        _singleton.trigger('open');
      }

      _private.openDepth++;

      var onFetch = function(parent) {
        var subregionPromises = [];
        // now fetch/render all sub regions
        _.each(parent.regions, function(subregion, name) {
          // Skip if the region has been nullified
          if (!subregion) return;
          var q = Q.defer();
          _singleton.region.open(subregion, function(_region) {
            if (_region.kind == BACKBONE_REGION && name != _region.name) {
              log.error('Region configured with name ' + name + ' but has name ' + _region.name);
            }

            parent.regions[name] = _region;
            q.resolve(_region);
          });
          subregionPromises.push(q.promise);
        });

        Q.allSettled(subregionPromises)
          .then(function() {
            if (callback) return callback(parent);
            if (_private.current) {
              if (_private.current.is(parent)) {
                _private.current.merge(parent, _singleton);
                return;
              } else if (_private.current.name == parent.name) {
                parent.render(_singleton);

                _private.current.replace(parent, function() {
                  _private.current.close();
                  _private.current = parent;
                  _private.current.appended();
                });
                return;
              }

              _private.current.close(true);
            }

            // HACK: Stop render when navigating back to ReactRouter before the region is ready
            if (!_singleton.dontRender) {
              _private.current = parent;
              $(_private.body).html(_private.current.render(_singleton).view.$el);
              _private.current.appended();
            }
          })
          .done(function() {
            if (--_private.openDepth <= 0) {
              // Set a event for RR to close the top level region
              _singleton.on('close', function() {
                _singleton.renderedRegions = [];

                if (_private.current) {
                  _private.current.view.once('view:closed', function() {
                    _private.current = undefined;
                  });
                  _private.current.close.call(_private.current);
                }
              });
              _singleton.trigger('opened');
            }
          });
      };

      if (region.prototype.isPrototypeOf(name)) {
        onFetch(name);
      } else {
        if (_.isObject(name)) {
          view = _.keys(name)[0];
          conf = name[view];
        }

        _singleton.region.fetch(view, conf, onFetch);
      }
    },
  };

  // HACK: Hooks to stop rendering when navigating back to ReactRouter before the region is ready
  this.interruptRender = function() {
    this.dontRender = true;
  }.bind(this);
  this.cancelInterrupt = function() {
    this.dontRender = false;
  }.bind(this);

  this.router = new router(); // global router
  this.store = {}; // allow the app to share global objects between views
  this.tracker = []; // push events that you want to track onto this object
};

_.extend(Origami.prototype, Backbone.Events);

export default Origami;
